class MasonryGallery extends HTMLElement {
  constructor() {
    super();

    this.visibleCount = parseInt(this.dataset.visibleCount) || 8;
    this.totalCount = parseInt(this.dataset.totalCount) || 0;
    this.currentVisible = this.visibleCount;

    this.grid = this.querySelector('.masonry-gallery__grid');
    this.items = this.querySelectorAll('.masonry-gallery__item');
    this.viewMoreBtn = this.querySelector('[data-view-more]');

    // Lightbox lives outside masonry-gallery (avoids .isolate stacking context)
    const sectionId = this.dataset.sectionId;
    this.lightbox = document.getElementById(`GalleryLightbox-${sectionId}`);

    if (this.lightbox) {
      this.lightboxImage = this.lightbox.querySelector('.masonry-lightbox__image');
      this.prevBtn = this.lightbox.querySelector('[data-lightbox-prev]');
      this.nextBtn = this.lightbox.querySelector('[data-lightbox-next]');
      this.thumbnailsContainer = this.lightbox.querySelector('[data-lightbox-thumbnails]');
      this.thumbs = this.lightbox.querySelectorAll('[data-thumb-index]');
    } else {
      this.thumbs = [];
    }

    // Parse gallery images data
    const dataEl = document.querySelector(`[data-gallery-images="${sectionId}"]`);
    this.images = dataEl ? JSON.parse(dataEl.textContent) : [];
    this.currentIndex = 0;

    this.bindEvents();
  }

  bindEvents() {
    // View more button
    if (this.viewMoreBtn) {
      this.viewMoreBtn.addEventListener('click', this.showMore.bind(this));
    }

    // Image click -> open lightbox
    this.querySelectorAll('[data-gallery-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = parseInt(btn.dataset.galleryIndex);
        this.openLightbox(index);
      });
    });

    // Lightbox navigation
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigateLightbox(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigateLightbox(1));
    }

    // Thumbnail clicks
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.thumbIndex);
        this.currentIndex = index;
        this.updateLightboxImage();
      });
    });

    // Keyboard navigation — listen on document so it works regardless of focus
    document.addEventListener('keyup', (e) => {
      if (!this.lightbox || !this.lightbox.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') this.navigateLightbox(-1);
      if (e.key === 'ArrowRight') this.navigateLightbox(1);
      if (e.key === 'Escape') this.lightbox.hide();
    });
  }

  showMore() {
    // Show all hidden items (both desktop and mobile)
    this.items.forEach((item) => {
      item.classList.remove('masonry-gallery__item--hidden', 'masonry-gallery__item--hidden-mobile');
      item.classList.add('masonry-gallery__item--visible');
    });

    // Hide button
    this.viewMoreBtn.classList.add('masonry-gallery__view-more--hidden');
  }

  openLightbox(index) {
    if (!this.lightbox || !this.images[index]) return;

    this.currentIndex = index;
    this.updateLightboxImage();
    this.lightbox.show();
  }

  navigateLightbox(direction) {
    this.currentIndex += direction;

    // Loop around
    if (this.currentIndex < 0) {
      this.currentIndex = this.images.length - 1;
    } else if (this.currentIndex >= this.images.length) {
      this.currentIndex = 0;
    }

    this.updateLightboxImage();
  }

  updateLightboxImage() {
    const imageData = this.images[this.currentIndex];
    if (!imageData || !this.lightboxImage) return;

    this.lightboxImage.classList.remove('loaded');

    const img = this.lightboxImage;
    img.onload = () => {
      img.classList.add('loaded');
    };
    img.src = imageData.src;
    img.alt = imageData.alt;

    // Update active thumbnail
    this.thumbs.forEach((thumb) => {
      thumb.classList.toggle(
        'masonry-lightbox__thumb--active',
        parseInt(thumb.dataset.thumbIndex) === this.currentIndex
      );
    });

    // Scroll active thumbnail into view
    const activeThumb = this.lightbox && this.lightbox.querySelector('.masonry-lightbox__thumb--active');
    if (activeThumb && this.thumbnailsContainer) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
}

customElements.define('masonry-gallery', MasonryGallery);
